import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "../../../scaffolding/router-api";

export const Route = createFileRoute("/_auth/_frame/abacus")({
  beforeLoad: () => {
    throw redirect({ to: "/library", replace: true });
  },
});
